export default {
  en: {
    "unsavedRowsError": "Please save all rows before proceeding.",
    "invalidRowsError": "Please correct invalid rows before proceeding.",
    "invalidRowError": "Invalid row. Please correct it or delete.",
    "alertMessageWithLabel": "{{label}}: {{message}}",
    "alertMessage": "{{message}}",
    "complete": "Submission Complete",
    "error": "Please fix the following errors before submitting.",
    "errorListHotkey": "Press Ctrl + Alt + X to go back to the error list.",
    "errorsListNavigationMessage": "Click to navigate to the field with following error.",
    "submitError": "Please check the form and correct all errors before submitting.",
    "required": "{{field}} is required",
    "unique": "{{field}} must be unique",
    "array": "{{field}} must be an array",
    "array_nonempty": "{{field}} must be a non-empty array",
    "nonarray": "{{field}} must not be an array",
    "select": "{{field}} contains an invalid selection",
    "pattern": "{{field}} does not match the pattern {{pattern}}",
    "minLength": "{{field}} must have at least {{length}} characters.",
    "maxLength": "{{field}} must have no more than {{length}} characters.",
    "minWords": "{{field}} must have at least {{length}} words.",
    "maxWords": "{{field}} must have no more than {{length}} words.",
    "min": "{{field}} cannot be less than {{min}}.",
    "max": "{{field}} cannot be greater than {{max}}.",
    "maxDate": "{{field}} should not contain date after {{- maxDate}}",
    "minDate": "{{field}} should not contain date before {{- minDate}}",
    "maxYear": "{{field}} should not contain year greater than {{maxYear}}",
    "minYear": "{{field}} should not contain year less than {{minYear}}",
    "invalid_email": "{{field}} must be a valid email.",
    "invalid_url": "{{field}} must be a valid url.",
    "invalid_regex": "{{field}} does not match the pattern {{regex}}.",
    "invalid_date": "{{field}} is not a valid date.",
    "invalid_day": "{{field}} is not a valid day.",
    "mask": "{{field}} does not match the mask.",
    "valueIsNotAvailable": "{{ field }} is an invalid value.",
    "stripe": "{{stripe}}",
    "month": "Month",
    "day": "Day",
    "year": "Year",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "next": "Next",
    "previous": "Previous",
    "cancel": "Cancel",
    "submit": "Submit Form",
    "confirmCancel": "Are you sure you want to cancel?",
    "saveDraftInstanceError": "Cannot save draft because there is no formio instance.",
    "saveDraftAuthError": "Cannot save draft unless a user is authenticated.",
    "restoreDraftInstanceError": "Cannot restore draft because there is no formio instance.",
    "time": "Invalid time",
    "Add/Remove": "Add/Remove",
    "Save": "Save",
    "Cancel": "Cancel",
    "Add": "Add",
    "Edit": "Edit",
    "Delete": "Delete",
    "Revert": "Revert",
    "File Name": "File Name",
    "Size": "Size",
    "Type": "Type",
    "Complete": "Complete",
    "No Matches Found": "Mo Matches Found",
    "Create Page": "Create Page",
    "Page": "Page",
    "Close": "Close",
    "Day": "Day",
    "Month": "Month",
    "Year": "Year",
    "Component": "Component",
    "Help": "Help",
    "Remove": "Remove",
    "Preview": "Preview",
    "Basic": "Basic",
    "Advanced": "Advanced",
    "Layout": "Layout",
    "Data": "Data",
    "Report": "Report",
    "Other": "Other",
    "Parameters": "Parameters",
    "Refresh": "Refresh",
    "Display": "Display",
  },
  fr: {
    "unsavedRowsError": "Veuillez enregistrer toutes les lignes avant de continuer.",
    "invalidRowsError": "Veuillez corriger les lignes non valides avant de continuer.",
    "invalidRowError": "Ligne invalide. Veuillez le corriger ou le supprimer.",
    "alertMessageWithLabel": "{{étiquette}} : {{message}}",
    "alertMessage": "{{message}}",
    "complete": "Soumission terminée",
    "error": "Veuillez corriger les erreurs suivantes avant de soumettre.",
    "errorListHotkey": "Appuyez sur Ctrl + Alt + X pour revenir à la liste des erreurs.",
    "errorsListNavigationMessage": "Cliquez pour accéder au champ avec l'erreur suivante.",
    "submitError": "Veuillez vérifier le formulaire et corriger toutes les erreurs avant de le soumettre.",
    "required": "{{Champ requis",
    "unique": "{{champ}} doit être unique",
    "array": "{{field}} doit être un tableau",
    "array_nonempty": "{{field}} doit être un tableau non vide",
    "nonarray": "{{field}} ne doit pas être un tableau",
    "select": "{{field}} contient une sélection invalide",
    "pattern": "{{field}} ne correspond pas au modèle {{pattern}}",
    "minLength": "{{field}} doit contenir au moins {{length}} caractères.",
    "maxLength": "{{field}} ne doit pas comporter plus de {{length}} caractères.",
    "minWords": "{{field}} doit contenir au moins {{length}} mots.",
    "maxWords": "{{field}} ne doit pas contenir plus de {{length}} mots.",
    "min": "{{field}} ne peut pas être inférieur à {{min}}.",
    "max": "{{field}} ne peut pas être supérieur à {{max}}.",
    "maxDate": "{{field}} ne doit pas contenir de date après {{- maxDate}}",
    "minDate": "{{field}} ne doit pas contenir de date avant {{- minDate}}",
    "maxYear": "{{field}} ne doit pas contenir d'année supérieure à {{maxYear}}",
    "minYear": "{{field}} ne doit pas contenir d'année inférieure à {{minYear}}",
    "invalid_email": "{{field}} doit être un e-mail valide.",
    "invalid_url": "{{field}} doit être une URL valide.",
    "invalid_regex": "{{field}} ne correspond pas au modèle {{regex}}.",
    "invalid_date": "{{field}} n'est pas une date valide.",
    "invalid_day": "{{field}} n'est pas un jour valide.",
    "mask": "{{field}} ne correspond pas au masque.",
    "valueIsNotAvailable": "{{ champ }} est une valeur invalide.",
    "stripe": "{{Bande}}",
    "month": "Mois",
    "day": "Jour",
    "year": "Année",
    "january": "Janvier",
    "february": "Février",
    "march": "Mars",
    "april": "Avril",
    "may": "Peut",
    "june": "Juin",
    "july": "Juillet",
    "august": "Août",
    "september": "Septembre",
    "october": "Octobre",
    "november": "Novembre",
    "december": "Décembre",
    "next": "Suivant",
    "previous": "Précédent",
    "cancel": "Annuler",
    "submit": "Soumettre le formulaire",
    "confirmCancel": "Es-tu sûre de vouloir annuler?",
    "saveDraftInstanceError": "Impossible d'enregistrer le brouillon car il n'y a pas d'instance formio.",
    "saveDraftAuthError": "Impossible d'enregistrer le brouillon tant qu'un utilisateur n'est pas authentifié.",
    "restoreDraftInstanceError": "Impossible de restaurer le brouillon car il n'y a pas d'instance formio.",
    "time": "Heure invalide",
    "Add/Remove": "Ajouter enlever",
    "Save": "Sauvegarder",
    "Cancel": "Annuler",
    "Add": "Ajouter",
    "Edit": "Modifier",
    "Delete": "Supprimer",
    "Revert": "Revenir",
    "File Name": "Nom de fichier",
    "Size": "Taille",
    "Type": "Taper",
    "Complete": "Complet",
    "No Matches Found": "Mo Matchs trouvés",
    "Create Page": "Créer une page",
    "Page": "Page",
    "Close": "Fermer",
    "Day": "Jour",
    "Month": "Mois",
    "Year": "Année",
    "Component": "Composant",
    "Help": "Aider",
    "Remove": "Retirer",
    "Preview": "Aperçu",
    "Basic": "Basique",
    "Advanced": "Avancé",
    "Layout": "Mise en page",
    "Data": "Données",
    "Report": "Rapport",
    "Other": "Autre",
    "Parameters": "Paramètres",
    "Refresh": "Rafraîchir",
    "Display": "Afficher",
  },
  de: {
    "unsavedRowsError": "Bitte speichern Sie alle Zeilen, bevor Sie fortfahren.",
    "invalidRowsError": "Bitte korrigieren Sie ungültige Zeilen, bevor Sie fortfahren.",
    "invalidRowError": "Ungültige Zeile. Bitte korrigieren oder löschen.",
    "alertMessageWithLabel": "{{label}}: {{message}}",
    "alertMessage": "{{Nachricht}}",
    "complete": "Einreichung abgeschlossen",
    "error": "Bitte beheben Sie die folgenden Fehler vor dem Absenden.",
    "errorListHotkey": "Drücken Sie Strg + Alt + X, um zur Fehlerliste zurückzukehren.",
    "errorsListNavigationMessage": "Klicken Sie, um zu dem Feld mit dem folgenden Fehler zu navigieren.",
    "submitError": "Bitte überprüfen Sie das Formular und korrigieren Sie alle Fehler, bevor Sie es absenden.",
    "required": "{{field}} ist erforderlich",
    "unique": "{{field}} muss eindeutig sein",
    "array": "{{field}} muss ein Array sein",
    "array_nonempty": "{{field}} muss ein nicht leeres Array sein",
    "nonarray": "{{field}} darf kein Array sein",
    "select": "{{field}} enthält eine ungültige Auswahl",
    "pattern": "{{field}} stimmt nicht mit dem Muster {{pattern}} überein",
    "minLength": "{{field}} muss mindestens {{length}} Zeichen haben.",
    "maxLength": "{{field}} darf nicht mehr als {{length}} Zeichen haben.",
    "minWords": "{{field}} muss mindestens {{length}} Wörter enthalten.",
    "maxWords": "{{field}} darf nicht mehr als {{length}} Wörter enthalten.",
    "min": "{{field}} darf nicht kleiner als {{min}} sein.",
    "max": "{{field}} darf nicht größer als {{max}} sein.",
    "maxDate": "{{field}} sollte kein Datum nach {{- maxDate}} enthalten",
    "minDate": "{{field}} sollte kein Datum vor {{-minDate}} enthalten",
    "maxYear": "{{field}} sollte kein Jahr enthalten, das größer als {{maxYear}} ist.",
    "minYear": "{{field}} sollte kein Jahr enthalten, das kleiner als {{minYear}} ist.",
    "invalid_email": "{{field}} muss eine gültige E-Mail-Adresse sein.",
    "invalid_url": "{{field}} muss eine gültige URL sein.",
    "invalid_regex": "{{field}} stimmt nicht mit dem Muster {{regex}} überein.",
    "invalid_date": "{{field}} ist kein gültiges Datum.",
    "invalid_day": "{{field}} ist kein gültiger Tag.",
    "mask": "{{field}} stimmt nicht mit der Maske überein.",
    "valueIsNotAvailable": "{{ field }} ist ein ungültiger Wert.",
    "stripe": "{{Streifen}}",
    "month": "Monat",
    "day": "Tag",
    "year": "Jahr",
    "january": "Januar",
    "february": "Februar",
    "march": "Marsch",
    "april": "April",
    "may": "Dürfen",
    "june": "Juni",
    "july": "Juli",
    "august": "August",
    "september": "September",
    "october": "Oktober",
    "november": "November",
    "december": "Dezember",
    "next": "Nächste",
    "previous": "Vorherige",
    "cancel": "Stornieren",
    "submit": "Formular abschicken",
    "confirmCancel": "Bist du sicher, dass du abbrechen möchtest?",
    "saveDraftInstanceError": "Der Entwurf kann nicht gespeichert werden, da keine Formio-Instanz vorhanden ist.",
    "saveDraftAuthError": "Der Entwurf kann nur gespeichert werden, wenn ein Benutzer authentifiziert ist.",
    "restoreDraftInstanceError": "Der Entwurf kann nicht wiederhergestellt werden, da keine Formio-Instanz vorhanden ist.",
    "time": "Ungültige Zeit",
    "Add/Remove": "Hinzufügen/Entfernen",
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "Add": "Hinzufügen",
    "Edit": "Bearbeiten",
    "Delete": "Löschen",
    "Revert": "Zurückkehren",
    "File Name": "Dateinamen",
    "Size": "Größe",
    "Type": "Typ",
    "Complete": "Vollständig",
    "No Matches Found": "Mo-Übereinstimmungen gefunden",
    "Create Page": "Seite erstellen",
    "Page": "Buchseite",
    "Close": "Schließen",
    "Day": "Tag",
    "Month": "Monat",
    "Year": "Jahr",
    "Component": "Komponente",
    "Help": "Hilfe",
    "Remove": "Entfernen",
    "Preview": "Vorschau",
    "Basic": "Basic",
    "Advanced": "Fortschrittlich",
    "Layout": "Layout",
    "Data": "Daten",
    "Report": "Bericht",
    "Other": "Andere",
    "Parameters": "Parameter",
    "Refresh": "Aktualisierung",
    "Display": "Anzeige",
  },
  fi: {
    "unsavedRowsError": "Tallenna kaikki rivit ennen kuin jatkat.",
    "invalidRowsError": "Korjaa virheelliset rivit ennen kuin jatkat.",
    "invalidRowError": "Virheellinen rivi. Korjaa tai poista se.",
    "alertMessageWithLabel": "{{label}}: {{message}}",
    "alertMessage": "{{viesti}}",
    "complete": "Lähetys valmis",
    "error": "Korjaa seuraavat virheet ennen lähettämistä.",
    "errorListHotkey": "Palaa virheluetteloon painamalla Ctrl + Alt + X.",
    "errorsListNavigationMessage": "Napsauta navigoidaksesi kenttään, jossa on seuraava virhe.",
    "submitError": "Tarkista lomake ja korjaa kaikki virheet ennen lähettämistä.",
    "required": "{{field}} on pakollinen",
    "unique": "{{field}} on oltava yksilöllinen",
    "array": "{{field}} on oltava jono",
    "array_nonempty": "{{field}} ei saa olla tyhjä taulukko",
    "nonarray": "{{field}} ei saa olla taulukko",
    "select": "{{field}} sisältää virheellisen valinnan",
    "pattern": "{{field}} ei vastaa mallia {{pattern}}",
    "minLength": "{{field}} tulee sisältää vähintään {{length}} merkkiä.",
    "maxLength": "{{field}} saa sisältää enintään {{length}} merkkiä.",
    "minWords": "{{field}} sisältää vähintään {{length}} sanaa.",
    "maxWords": "{{field}} saa sisältää enintään {{length}} sanaa.",
    "min": "{{field}} ei voi olla pienempi kuin {{min}}.",
    "max": "{{field}} ei voi olla suurempi kuin {{max}}.",
    "maxDate": "{{field}} ei saa sisältää päivämäärää {{- maxDate}} jälkeen",
    "minDate": "{{field}} ei saa sisältää päivämäärää ennen {{- minDate}}",
    "maxYear": "{{field}} ei saa sisältää vuotta, joka on suurempi kuin {{maxYear}}",
    "minYear": "{{field}} ei saa sisältää vuotta vähemmän kuin {{minYear}}",
    "invalid_email": "{{field}} on oltava kelvollinen sähköpostiosoite.",
    "invalid_url": "{{field}} on oltava kelvollinen URL-osoite.",
    "invalid_regex": "{{field}} ei vastaa mallia {{regex}}.",
    "invalid_date": "{{field}} ei ole kelvollinen päivämäärä.",
    "invalid_day": "{{field}} ei ole kelvollinen päivä.",
    "mask": "{{field}} ei vastaa maskia.",
    "valueIsNotAvailable": "{{ kenttä }} on virheellinen arvo.",
    "stripe": "{{raita}}",
    "month": "Kuukausi",
    "day": "Päivä",
    "year": "vuosi",
    "january": "tammikuu",
    "february": "helmikuu",
    "march": "maaliskuuta",
    "april": "huhtikuu",
    "may": "saattaa",
    "june": "kesäkuuta",
    "july": "heinäkuu",
    "august": "elokuu",
    "september": "syyskuu",
    "october": "lokakuu",
    "november": "marraskuu",
    "december": "joulukuu",
    "next": "Seuraava",
    "previous": "Edellinen",
    "cancel": "Peruuttaa",
    "submit": "Lähetä lomake",
    "confirmCancel": "Oletko varma, että haluat peruuttaa?",
    "saveDraftInstanceError": "Luonnosta ei voi tallentaa, koska formio-instanssia ei ole.",
    "saveDraftAuthError": "Luonnosta ei voi tallentaa, ellei käyttäjää ole todennettu.",
    "restoreDraftInstanceError": "Luonnosta ei voi palauttaa, koska formio-instanssia ei ole.",
    "time": "Virheellinen aika",
    "Add/Remove": "Lisää poista",
    "Save": "Tallentaa",
    "Cancel": "Peruuttaa",
    "Add": "Lisätä",
    "Edit": "Muokata",
    "Delete": "Poistaa",
    "Revert": "Palauta",
    "File Name": "Tiedoston nimi",
    "Size": "Koko",
    "Type": "Tyyppi",
    "Complete": "Saattaa loppuun",
    "No Matches Found": "Mo Osumia löytyi",
    "Create Page": "Luo sivu",
    "Page": "Sivu",
    "Close": "kiinni",
    "Day": "Päivä",
    "Month": "Kuukausi",
    "Year": "vuosi",
    "Component": "Komponentti",
    "Help": "auta",
    "Remove": "Poista",
    "Preview": "Esikatselu",
    "Basic": "Perus",
    "Advanced": "Pitkälle kehittynyt",
    "Layout": "Layout",
    "Data": "Data",
    "Report": "Raportoi",
    "Other": "Muut",
    "Parameters": "Parametrit",
    "Refresh": "virkistää",
    "Display": "Näyttö"
  }
};

